/**
 * `/signin/denied` — TASK 7.4 Step 1 (AC 1.3).
 *
 * Extracted VERBATIM from the mock's `rDenied` block (L63-72):
 *
 *   div[data-screen-label="Sign in denied"] .sm-screen-center.sm-screen-center--text
 *     div .sm-auth-card--wide .sm-anim-up
 *       div .sm-glyph--invite                       "INVITE ONLY"          L66
 *       h1  .sm-status-title [data-h1][tabindex=-1] "Access is by invitation only"  L67
 *       p   .sm-body                                "That Google account…" L68
 *       a   .sm-btn .sm-btn--accent  href="#/signin" "Back to sign-in"     L69
 *
 * The h1 copy is AC 1.3's exact string and ui-contract §9's exact string; it
 * is also `router.js`'s `signin-denied` title, so the two cannot drift.
 *
 * This screen is reached three ways, all real:
 *   1. `GET /api/auth/google/callback` → 302 `/signin/denied` for an account
 *      that is not on the allowlist (`routes/auth.ts`, no session minted);
 *   2. the global 403 revocation handler after a mid-session removal
 *      (`api/api-client.ts`, AC 2.5) — which purges first;
 *   3. a direct visit.
 * (1) arrives as a PATH; `guard.js#normalizeEntryPath` promotes it to the hash
 * route at boot, otherwise the hash router would silently render Home.
 *
 * @module
 */

import { TESTIDS } from '@streamymusic/shared';

import { append, el } from '../../components/primitives/dom.js';
import { Button } from '../../components/primitives/Button.js';

/**
 * @returns {HTMLElement}
 */
export function Denied() {
  const card = el('div', { className: 'sm-auth-card--wide sm-anim-up' });
  append(
    card,
    el('div', { className: 'sm-glyph--invite', text: 'INVITE ONLY' }), // L66
    el('h1', {
      className: 'sm-status-title',
      text: 'Access is by invitation only',
      testId: TESTIDS.PAGE_HEADING,
      attrs: { tabindex: '-1', 'data-h1': '' },
    }), // L67
    el('p', {
      className: 'sm-body',
      text: "That Google account isn't on the guest list. Ask the library owner to add you, then try again.",
    }), // L68
    Button({
      label: 'Back to sign-in',
      variant: 'accent',
      href: '#/signin',
      testId: TESTIDS.BACK_TO_SIGN_IN_LINK,
    }), // L69
  );

  return append(
    el('div', {
      className: 'sm-screen-center sm-screen-center--text',
      attrs: { 'data-screen-label': 'Sign in denied' },
    }),
    card,
  );
}
